// tslint:disable: variable-name
import { Paciente } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { PacienteItens } from './paciente-itens.model';

export class PacienteProcesso extends BaseResourceModel {
    constructor(
        public id?: number,
        public numero?: number,
        public procurador_responsavel?: string,
        public vara?: string,
        public acao?: string,
        public status?: 'Ativo' | 'Suspenso' | 'Arquivado' | 'Finalizado',
        public tipo_acao?: 'S' | 'N',
        public paciente?: Paciente,
        public itens_processo?: PacienteItens[]
    ) {
        super();
    }
    static converteJson(json: any): PacienteProcesso {
        return Object.assign(new PacienteProcesso(), json);
    }
}
